import { useSearchParams as useLiveRenderingSearchParams } from '@ad-lucy/services/LiveRendering';
import { useCallback } from 'react';

// Regular expression to find the value after "branch/" and before the next "/"
const UNIVERSAL_BRANCH_REGEX = /\/branch\/([^/]+)\//;

export const useContentUrl = (contentUrl: string | undefined) => {
  const { previewMode } = useLiveRenderingSearchParams();

  return useCallback(
    (id: string) => {
      if (contentUrl && previewMode === 'liveRendering') {
        return contentUrl.replace(UNIVERSAL_BRANCH_REGEX, `/branch/${id}/`);
      }

      return `content/content-${id}.json`;
    },
    [contentUrl, previewMode],
  );
};
